import React, { useCallback } from 'react'
import { Box, Grid, Typography } from '@material-ui/core'

import { PageTitle } from 'Components/PageTitle'
import H2HEmptyState from '../../../../Assets/Images/icons/h2hEmptyState'
import { CAMPAING_TYPE_PARAM_TO_EMPTY_TITLE } from '../../../../shared/constants'

import { EmptyStateSimpleBtn } from '../CampaignEmptyStateButtons'
import EmptyStateMessage from '../EmptyStateMessage'
import usePosthogAnalyticsH2H from './hooks/usePosthogAnalyticsH2H'

const CampaignEmptyStateH2H = ({
  classes,
  isSelfServeEnabled,
  handleCreateCampaign,
  validRoute,
  enabledChannel,
  route,
}) => {
  const { emitAnalyticsEvent } = usePosthogAnalyticsH2H()

  const handleClick = useCallback(async () => {
    await handleCreateCampaign()
    emitAnalyticsEvent()
  }, [handleCreateCampaign])

  return (
    <React.Fragment>
      {!enabledChannel && (
        <EmptyStateMessage title="Sorry, this channel is currently not available to create a campaign in your country." />
      )}
      <Box className={classes.campaignWrapper}>
        <PageTitle className={classes.title}>
          {CAMPAING_TYPE_PARAM_TO_EMPTY_TITLE[route]}
        </PageTitle>
        <Grid
          container
          spacing={3}
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={12} sm={7}>
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              <p className={classes.emptyStateText}>
                Flyering campaigns offer a highly effective channel for
                advertisers aiming to physically engage with potential
                customers. This method allows for precise targeting and
                remarkable efficiency.
              </p>
              <p className={classes.emptyStateText}>
                Utilize our campaign builder to choose your preferred locations,
                dates, and times. To assist you in identifying the most
                adventageous locations, we provide recommended locations as well
                as heat maps showcasing foot traffic data.
              </p>
              <p className={classes.emptyStateText}>
                Exploring this channel doesn't requiere a large investment; you
                can experiment and gain insights for under three digits!
              </p>
            </Box>
            <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
              <p className={classes.emptyStateText}>
                Easily launch a flyering campaign by selecting locations and
                times for distribution and using our foot traffic data for
                guidance. No large investment is required—experiment and gain
                insights for under 3-figures
              </p>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4} className="text-center">
            <H2HEmptyState />
          </Grid>
        </Grid>
        {validRoute && enabledChannel && (
          <Box className={classes.btnWrapper}>
            <Typography className={classes.btnTitle}>
              {isSelfServeEnabled
                ? "Let's create your first campaign!"
                : 'Once you have a campaign, you’ll be able to see it here'}
            </Typography>
            {isSelfServeEnabled && (
              <EmptyStateSimpleBtn classes={classes} onClick={handleClick} />
            )}
          </Box>
        )}
      </Box>
    </React.Fragment>
  )
}

export default CampaignEmptyStateH2H
